/** @module csi/widget/_svg/ImagePlaceholderShape */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-style",
	"dijit/form/ComboButton",
	"csi/_base/underscore",
	"csi/locale",
	"../SvgShapePalette",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(declare,lang,domClass,style,ComboButton,_,locale,SvgShapePalette,_Plugin,PluginFactory, util) {

	return PluginFactory.declare([ComboButton, _Plugin], {
		"class": "csi-button-toggle csi-single-toggle",
		iconClass: "csiActionIcon",
		pluginName: "imagePlaceholderShape",
		propertyKey: util.shapeProperties.imagePlaceholderShape,

		/**
		 * @override
		 * Create shape palette and initialize icon
		 */
		postCreate: function() {
			this.dropDown = new SvgShapePalette({
				onChange: lang.hitch(this, this.onChangeShape)
			});

			var imagePlaceholderShapeType = this.editor.getStorageProperty("shapeProperties.spPr.geometry.presetShape") || "rect";
			var shape = this.dropDown.getShapeByType(imagePlaceholderShapeType);
			this._updateShape(shape);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			var value;
			var shape;
			var slength = shapes.length;
			var enabled = this.inherited(arguments);

			if (this.propertyKey && slength) {
				value = this.editor.canvasApp.selection.getCommonValue(shapes, this.propertyKey);

				if (!value) {
					value = "rect";
				}
			} else {
				value = this.editor.getStorageProperty("shapeProperties.spPr.geometry.presetShape") || "rect";
			}

			this.dropDown.initValueByType(value);
			shape = this.dropDown.getShapeByType(value);
			this._updateShape(shape);

			return enabled && this.editor.allSelectedObjectsAreFromImagePlaceholders();
		},


		/**
		 * Update icon and set draw mode
		 * @param  {Object} shape
		 */
		onChangeShape: function(shape) {
			this._updateShape(shape);
			this.editor.setShapeProperty(util.shapeProperties.imagePlaceholderShape, shape.shapeType);

			// If dropdown shape was changed and no shapes are selected, set draw mode shape.
			if (!this.editor.canvasApp.selection.selectedObjects().length) {
			    this.editor.setDrawMode(shape.shapeType, true, false, false, true);
			}
		},

		/**
		 * Update current shape used for image placeholders
		 * @param  {Object} value
		 */
		_updateShape: function(shape) {
			var shape = shape || this.dropDown.get("value");

			if (shape) {
				this.set("title", locale.resource(shape.title));
				this.set("iconClass", "csiActionIcon " + shape.icon);
			}
		}
	});
});
